import { convertSvgToCimdoc, RenderingFormat } from '@cimpress-technology/svg-to-cimdoc';
import { ShapesSvgDefaults } from 'utility/constants';
import { Shape, ShapeTypes } from './shapeData/types.shapes';
import { getSvgFromShape } from './shapeData/utility.shapes';
import { AuthConfig } from './types';

interface AppUserData {
    tenantId: string;
    hostApp: string;
    authConfig: AuthConfig;
}

let currentShape: Shape;
let appUserData: AppUserData;

export function getCurrentSvg(
    width?: number,
    height?: number,
): Promise<string> {
    const { fillColor, stroke, strokeWidth, viewBoxWidth } = ShapesSvgDefaults;
    return getSvgFromShape(currentShape,
        width || viewBoxWidth,
        height || viewBoxWidth,
        stroke,
        strokeWidth,
        fillColor);
}

function getModuleFromShape(
    shapeType: ShapeTypes,
    mmWidth: number,
    mmHeight: number,
): Promise<RenderingFormat> {
    return new Promise(((resolve) => {
        resolve(({
            type: shapeType,
            position: {
                x: '0mm',
                y: '0mm',
                height: `${mmHeight}mm`,
                width: `${mmWidth}mm`,
            },
            curves: [],
            viewBox: { x: '0mm', y: '0mm', height: `${mmHeight}mm`, width: `${mmWidth}mm` },
            stroke: {
                color: `rgb(${ShapesSvgDefaults.stroke})`,
                thickness: `${ShapesSvgDefaults.strokeWidth}pt`,
            },
            color: `rgb(${ShapesSvgDefaults.fillColor})`,
        }));
    }));
}

export function getCurrentShapeInRenderingFormat(
    mmWidth?: number,
    mmHeight?: number,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<any> {
    const newWidth = mmWidth || ShapesSvgDefaults.viewBoxWidth;
    let newHeight = mmHeight || ShapesSvgDefaults.viewBoxWidth;
    const shapeType = currentShape.type;
    if (
        shapeType === ShapeTypes.Rectangle
        || shapeType === ShapeTypes.Ellipse
        || shapeType === ShapeTypes.Line
    ) {
        newHeight = shapeType === ShapeTypes.Line ? 1 : newHeight;
        return getModuleFromShape(
            shapeType,
            newWidth,
            newHeight,
        ).then((data) => [data]); // returning an array
    }
    return getCurrentSvg(newWidth, newHeight)
        .then((svg) => convertSvgToCimdoc({
            svgString: svg,
            widthInMM: newWidth,
            shouldMergePath: true,
        }).then((data: RenderingFormat[]) => data));
}

export function setCurrentShape(shape: Shape): void {
    currentShape = shape;
}

export function getCurrentShape(): Shape {
    return currentShape;
}

export function setAppUser(appUser: AppUserData): void {
    appUserData = appUser;
}

export function getAppUser(): AppUserData {
    return appUserData;
}
